'use client';

import { funnelData } from '@/features/admin/presentation/data/mockData';
import { motion } from 'framer-motion';

export function DashboardFunil() {
  const max = funnelData[0].value;

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl border border-admin-border p-6 shadow-sm">
        <h3 className="text-sm font-semibold text-admin-text mb-6">Funil de Analytics</h3>
        <div className="space-y-3 max-w-2xl mx-auto">
          {funnelData.map((stage, i) => {
            const pct = (stage.value / max) * 100;
            const convRate =
              i > 0 ? ((stage.value / funnelData[i - 1].value) * 100).toFixed(1) : '100';
            return (
              <div key={stage.stage} className="space-y-1">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-admin-text font-medium">{stage.stage}</span>
                  <span className="text-admin-text-secondary">
                    {stage.value.toLocaleString('pt-BR')}
                    {i > 0 && (
                      <span className="ml-2 text-xs text-admin-cyan-dark">({convRate}%)</span>
                    )}
                  </span>
                </div>
                <div className="h-8 bg-admin-bg-block rounded-lg overflow-hidden">
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${pct}%` }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                    className="h-full rounded-lg"
                    style={{
                      background:
                        'linear-gradient(90deg, #0D1B5E 0%, #1A2E7A 50%, #4AB8E0 100%)',
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

